import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, SearchX, ShieldAlert } from 'lucide-react';
export const Problem = () => {
  const problems = [{
    icon: <Clock className="w-6 h-6 text-red-400" data-id="element-231" />,
    title: 'Perdés horas redactando desde cero',
    desc: 'Cada nuevo caso de salud implica empezar de cero, buscando formatos y perdiendo tiempo valioso que podrías dedicar a conseguir más clientes.'
  }, {
    icon: <SearchX className="w-6 h-6 text-red-400" data-id="element-232" />,
    title: 'Jurisprudencia dispersa',
    desc: 'Pasás horas buscando fallos actualizados y fundamentos sólidos para respaldar tus escritos ante las negativas de las prepagas.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-red-400" data-id="element-233" />,
    title: 'Inseguridad al accionar',
    desc: 'La duda constante de si el amparo está bien planteado o si la obra social encontrará un hueco legal para rechazar la cobertura.'
  }, {
    icon: <AlertCircle className="w-6 h-6 text-red-400" data-id="element-234" />,
    title: 'Improvisación forzada',
    desc: 'Ante una urgencia médica de un cliente, no tenés un sistema probado y rápido para interponer la medida cautelar a tiempo.'
  }];
  return <section className="py-20 bg-legal-900" data-id="element-235">
      <div className="container mx-auto px-4" data-id="element-236">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-237">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-238">
            Llevar casos de salud sin un sistema probado{' '}
            <span className="text-red-400" data-id="element-239">es agotador.</span>
          </h2>
          <p className="text-lg text-slate-400" data-id="element-240">
            El derecho a la salud no espera. Cuando un cliente llega con una
            urgencia médica o una negativa de cobertura, cada minuto cuenta.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-241">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-legal-800/50 border border-red-900/30 p-6 rounded-xl flex gap-4" data-id="element-242">
              <div className="shrink-0 mt-1" data-id="element-243">{prob.icon}</div>
              <div data-id="element-244">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-245">
                  {prob.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-246">
                  {prob.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};